import React, { useState, useEffect, useContext } from "react";

// import { createMuiTheme, ThemeProvider } from '@mui/private-theming';
import { createTheme, ThemeProvider } from "@mui/material/styles";

import colors from "../../../assets/styles/variables/_colors.module.scss";
import { grey } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    // mode: "dark",
    primary: {
      main: colors["main-color-1"],
      dark: colors["main-color-1-dark"],
      light: colors["main-color-1-light"],
      xlight: colors["main-color-1-xlight"],
      contrastText: colors["main-color-1-contrast"],
    },
    primary2: {
      main: colors["main-color-2"],
      dark: colors["main-color-2-dark"],
      light: colors["main-color-2-light"],
      contrastText: colors["main-color-2-contrast"],
    },
    primary3: {
      main: colors["main-color-3"],
      dark: colors["main-color-3-dark"],
      light: colors["main-color-3-light"],
      contrastText: colors["main-color-3-contrast"],
    },
    primary4: {
      main: colors["main-color-4"],
      dark: colors["main-color-4-dark"],
      light: colors["main-color-4-light"],
      contrastText: colors["main-color-4-contrast"],
    },
    error: {
      main: "#EF3939",
    },
    success: {
      main: "#139608",
      light: "#1de30c",
    },
    gold: {
      main: "#FFDC64",
    },
    grey: {
      main: grey[500],
      dark: grey[400],
      light: grey[800],
      contrastText: grey[100],
    },
  },
});

const MaterialTheme = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export const useTheme = () => {
  return useContext(theme);
};

export default MaterialTheme;
